module.exports = __webpack_public_path__ + "static/error_page-208679f1399d8af193c383de7e2473d7.svg";